import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_component_base_button, {
    width: "narrow",
    theme: "default",
    "aria-label": _ctx.Resources.Common.ShareToFacebookButtonLabel,
    onClick: _cache[0] || (_cache[0] = $event => ($options.share($props.url)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_icon, {
        name: "facebook",
        "icon-namespace": "brands",
        class: _normalizeClass(['gfu-icon gfu-icon--fw', $options.sizeClassName])
      }, null, 8 /* PROPS */, ["class"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["aria-label"]))
}